





















































































































































































































































































































































































import { CourseDetails } from '@/jbi-shared/dto/jtms.dtos';
import {
  GroupLevelAttributeOption,
  GroupLevelAttributeStatus,
  GroupLevelAttributeValue
} from '@/jbi-shared/types/jaas-group-level-attributes.types';
import { CourseStatus } from '@/jbi-shared/types/jtms.types';
import { deepCopy } from '@/jbi-shared/util/deep-copy.util';
import { clone } from '@/jbi-shared/util/group-level-attributes.util';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import {
  ATTRIBUTE_MAX_DISPLAY_COUNT,
  CONTACT_OPTIONS_MAX_DISPLAY_COUNT
} from '@/store/modules/jtms/course/course.types';
import {
  TrainerResponseDTO,
  TrainerStatus
} from '@/store/modules/jtms/trainer/trainer.types';
import TableSectionTitle from '@/views/AdminViewGroup/components/TableSectionTitle.vue';
import ContactOption from '@/views/JTMS/Dashboard/ViewCourses/components/ContactOption.vue';
import ContactsToggleLabel from '@/views/JTMS/Dashboard/ViewCourses/components/ContactsToggleLabel.vue';
import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import {
  GroupLevelAttributeContactsType,
  GroupTitleAndLogo
} from '../../../../store/modules/admin/types/group-level-attribute.types';
import { RootState } from '../../../../store/store';
import { ApiState } from '../../../../store/types/general.types';
import AdministrationFeeItem from './components/AdministrationFeeItem.vue';

@Component({
  components: {
    ContactOption,
    ContactsToggleLabel,
    TableSectionTitle,
    AdministrationFeeItem
  }
})
export default class GroupLevelAttributeView extends Vue {
  @Prop() groupId!: number;
  @Prop({ default: false }) isCourseView!: boolean;
  @Prop({ default: false }) hasCourseModules!: boolean;
  @Prop(Object) courseDetails!: CourseDetails;

  allTrainers: TrainerResponseDTO[] = [];
  isRemovedTrainer: boolean = false;
  localAttributeValues: GroupLevelAttributeValue[] = [];
  totalAttributeCount: number = 0;
  isCoursePublished: boolean = false;
  localListOfContacts: GroupLevelAttributeContactsType[] | null = null;
  trainerObjs: TrainerStatus[] = [];
  trainerNames: string = '';

  @Action('admin/getGroupLevelAttributeValuesByGroupId')
  getCurrentGroupAttributeValues!: (groupId: number) => void;

  @Action('trainer/getTrainers')
  getAllTrainers!: () => void;

  @Action('course/storeListOfContacts')
  storeListOfContacts!: (payload: GroupLevelAttributeContactsType[]) => void;

  @State((state: RootState) => state.trainer.trainers)
  trainers!: TrainerResponseDTO[];

  @State(({ trainer }: RootState) => trainer.apiState.getTrainers)
  getAllTrainersApiState!: ApiState;

  @State(
    ({ admin }: RootState) =>
      admin.apiState.getGroupLevelAttributeValuesByGroupId
  )
  getGroupLevelAttributeValuesByGroupIdState!: ApiState;

  @State(({ admin }: RootState) => admin.groupLevelAttributeValuesByGroupId)
  public currentGroupAttributeValues!: GroupLevelAttributeValue[];

  @State(
    ({ course }: RootState) => course.courseLevelAttributeState.listOfContacts
  )
  public currentListOfContacts!: GroupLevelAttributeContactsType[];

  get contactListCount() {
    return this.currentListOfContacts?.length ?? 0;
  }

  get attributeCount() {
    return this.localAttributeValues?.length ?? 0;
  }

  get shouldEnableContactOptionToggle() {
    return this.contactListCount > CONTACT_OPTIONS_MAX_DISPLAY_COUNT;
  }

  get shouldEnableAttributeTableToggle() {
    return this.totalAttributeCount >= ATTRIBUTE_MAX_DISPLAY_COUNT;
  }

  get contactsHasValue() {
    return this.currentListOfContacts.some(
      (contacts) =>
        contacts.contactOptions
          .map((options) => options.value)
          .filter((val) => val)
          .join(', ').length > 0
    );
  }

  get locationHasValue() {
    const locationAttribute:
      | GroupLevelAttributeValue
      | undefined = this.localAttributeValues.find(
      (attr) =>
        attr.label === 'Location' &&
        attr.groupLevelAttributeType.type === 'location'
    );

    if (!locationAttribute) {
      return false;
    }

    const locationAttributeValue = locationAttribute.value as GroupLevelAttributeOption[];

    // Remove location type option, this attribute only has values
    // if other fields are populated
    const clonedLocationAttributeValues: GroupLevelAttributeOption[] = deepCopy(
      locationAttributeValue
    );
    clonedLocationAttributeValues.pop();

    return clonedLocationAttributeValues.some((fields) => fields.value);
  }

  public mounted() {
    this.getCurrentGroupAttributeValues(this.groupId);
    if (this.isCourseView) {
      this.isCoursePublished =
        this.courseDetails.status === CourseStatus.PUBLISHED;

      if (!this.trainers) {
        this.getAllTrainers();
      }
    }
  }

  administrationFeeAsObject(
    attribute: GroupLevelAttributeValue
  ): GroupLevelAttributeOption[] {
    return attribute.value as GroupLevelAttributeOption[];
  }

  trainersAsObjects(attribute: GroupLevelAttributeValue): TrainerStatus[] {
    if (!attribute.value) {
      return [];
    }

    const deletedTrainers = this.allTrainers.filter(
      (trainer) => trainer.deletedAt !== null
    );

    const transformedTrainersArray = (attribute.value as string[]).map(
      (trainer) => {
        const [name, idStr] = trainer.split('.');
        const id = parseInt(idStr, 10);

        const matchedTrainer = this.allTrainers.find(
          (trainerItem) => trainerItem.id === id
        );

        const isDeleted = deletedTrainers.some(
          (deletedTrainer) => deletedTrainer.id === id
        );

        return {
          id,
          name,
          accreditation: matchedTrainer?.accreditation ?? 'None',
          isDeleted
        };
      }
    );

    this.trainerNames = transformedTrainersArray.map((t) => t.name).join(', ');
    return transformedTrainersArray;
  }

  renderTimezone(attribute: GroupLevelAttributeValue) {
    if (attribute.value && typeof attribute.value === 'string') {
      const displayTimezone: string = (attribute.value as string).split(
        '.'
      )?.[0];

      // Only represent timezone offsets with GMT
      const replacedTimezone: string = displayTimezone.replace(/UTC/g, 'GMT');
      return replacedTimezone;
    }

    return '';
  }

  attributeType(attribute: GroupLevelAttributeValue): string {
    return attribute.groupLevelAttributeType.type;
  }

  shouldDisplayAsPlainText(attribute: GroupLevelAttributeValue) {
    if (
      this.attributeType(attribute) === 'text' ||
      this.attributeType(attribute) === 'email' ||
      this.attributeType(attribute) === 'integer' ||
      this.attributeType(attribute) === 'boolean' ||
      this.attributeType(attribute) === 'phone' ||
      this.attributeType(attribute) === 'organisation'
    ) {
      return true;
    } else {
      return false;
    }
  }

  getTrainersAsList(attribute: GroupLevelAttributeValue) {
    return attribute.value as string[];
  }

  // Custom render logic for trainers.
  // Refer to `GroupLevelAttributeTrainerField` for more details.
  renderTrainers(attribute: GroupLevelAttributeValue): string {
    return (attribute.value as string[])
      .map((value) => {
        // Only retrieve the name
        const [name, id] = value.split('.');
        return name;
      })
      .join(', ');
  }

  /* Addresses and coordinates requires extra massaging before rendering.
   * Empty values in field should not be shown. */
  renderAddress(attribute: GroupLevelAttributeValue): string {
    return (
      (attribute.value as GroupLevelAttributeOption[])
        .map((option) => option.value)
        .filter((value) => value)
        /* Value could be null or empty string. Display only the ones with content */
        .join(', ')
    );
  }

  assignListOfContacts() {
    const listOfContacts =
      (this.currentGroupAttributeValues.find(
        (gla) =>
          gla.label.trim().toLocaleLowerCase() === 'contacts' &&
          gla.groupLevelAttributeType.type === 'contact'
      )?.value as GroupLevelAttributeContactsType[]) ?? [];

    // Using state to restore original list of contacts retrieved from DB
    this.storeListOfContacts(listOfContacts);

    this.toggleListOfContacts(this.shouldEnableContactOptionToggle);
  }

  toggleListOfAttributes(isCollapsed: boolean) {
    this.restoreAttributeValues();
    if (this.isCourseView) {
      this.processAttributeValueDisplayForCourses();
    } else {
      this.processAttributeValueDisplayForGroups();
    }
    this.totalAttributeCount = this.localAttributeValues.length;
    if (isCollapsed) {
      this.hideAttributeValuesList();
    }
  }

  toggleListOfContacts(isCollapsed: boolean) {
    this.restoreListOfContacts();

    if (isCollapsed) {
      this.hideListOfContacts();
    }
  }

  getLocationType(attribute: GroupLevelAttributeValue): string {
    return (
      ((attribute.value as GroupLevelAttributeOption[])[8].value as string) ??
      'Venue'
    );
  }

  renderLocation(attribute: GroupLevelAttributeValue): string {
    const clonedAttributeVal: GroupLevelAttributeOption[] = deepCopy(
      attribute.value as GroupLevelAttributeOption[]
    );
    const venueGLAOptions = clonedAttributeVal.filter(
      (option) =>
        option.placeholder !== 'Meeting Link' &&
        option.placeholder !== 'Location Type'
    );
    return (
      (venueGLAOptions as GroupLevelAttributeOption[])
        .map((option) => option.value)
        .filter((value) => value)
        /* Value could be null or empty string. Display only the ones with content */
        .join(', ')
    );
  }

  renderLink(attribute: GroupLevelAttributeValue): string {
    const clonedAttributeVal: GroupLevelAttributeOption[] = deepCopy(
      attribute.value as GroupLevelAttributeOption[]
    );
    const link = clonedAttributeVal.find(
      (option) => option.placeholder === 'Meeting Link'
    )!.value;

    return link as string;
  }

  getStatusDisplayName(status: string): string {
    switch (status) {
      case 'DRAFT':
        return 'Draft';
      case 'IN_PROGRESS':
        return 'In progress';
      case 'CANCELLED':
        return 'Cancelled';
      case 'PUBLISHED':
        return 'Published';
      case 'COMPLETED':
        return 'Completed';
      default:
        return 'Draft';
    }
  }

  getVisibilityDisplayName(visibility: string): string {
    switch (visibility) {
      case 'PRIVATE':
        return '(Private)';
      case 'PUBLIC':
        return '(Public)';
      default:
        return '(Private)';
    }
  }

  getGoogleMapsUrl(latitude: string, longitude: string): string {
    return `https://www.google.com/maps/dir/${latitude},${longitude}`;
  }

  parseDate(date: string): string {
    return dayjs(date).format('DD MMM YYYY');
  }

  parseDatetime(date: string): string {
    return dayjs(date).format('DD MMM YYYY h[:]mmA');
  }

  isHiddenGLAValue(glav: GroupLevelAttributeValue): boolean {
    return (
      glav.groupLevelAttributeType.type === 'list' &&
      (glav.label.toLowerCase() === 'course type' ||
        glav.label.toLowerCase() === 'status')
    );
  }

  @isTruthy
  @Watch('getGroupLevelAttributeValuesByGroupIdState', { deep: true })
  getGroupLevelAttributeValuesByGroupIdStateSuccess(state: ApiState) {
    if (state.success) {
      this.localAttributeValues = [];
      this.localAttributeValues = clone(this.currentGroupAttributeValues);

      if (this.isCourseView) {
        this.processAttributeValueDisplayForCourses();
      } else {
        // Group View
        this.processAttributeValueDisplayForGroups();
      }
      this.totalAttributeCount = this.localAttributeValues.length;
      this.reduceAttributeValueList();
    }
  }

  processAttributeValueDisplayForCourses() {
    this.localAttributeValues = this.localAttributeValues.filter(
      (glav) => !this.isHiddenGLAValue(glav)
    );
    /**
     * Due to how b-tables work, a table cannot be appended with new row after it has been rendered.
     * A `:data` prop which is assigned `clonedAttributeValues` is iterated over under the hood to
     * generate the rows. Hence, in order to render custom rows on the table, the array has to be
     * appended with a custom object with minimum type requirements.
     *
     * Since this is used explicitly in frontend only, and none of the data will require modification
     * from the view UI, this is a reasonable workaround without having to perform changes from the
     * parent level.
     */
    const statusAsGLA: GroupLevelAttributeValue = {
      label: 'Status',
      groupLevelAttributeType: {
        id: 0,
        type: 'status',
        option: null
      },
      groupLevelAttributeSpec: {
        order: this.localAttributeValues.length + 1,
        isRequired: false
      },
      option: null,
      value: this.courseDetails.status,
      attributeStatus: GroupLevelAttributeStatus.ACTIVE
    };

    this.localAttributeValues.splice(0, 0, statusAsGLA);

    if (this.hasCourseModules) {
      this.processTrainerDisplayForCoursesWithCourseModules();
    }

    this.assignListOfContacts();
  }

  /**
   * If a course has course modules, the trainer field should still be rendered,
   * containing all the trainers from the course modules.
   *
   * Since this is used explicitly in frontend only, and none of the data will require modification
   * from the view UI, this is a reasonable workaround without having to perform changes from the
   * parent level.
   */
  processTrainerDisplayForCoursesWithCourseModules() {
    const locationGLAIndex: number = this.localAttributeValues.findIndex(
      (gla) =>
        gla.groupLevelAttributeType.type === 'location' &&
        gla.label === 'Location'
    );

    let trainerGLAValue: string[] = [];
    if (this.trainers) {
      // Construct trainer GLA value object
      const trainerIds = this.courseDetails.courseModules.flatMap(
        // Fallback to an empty array if cm.trainers is null/undefined
        (cm) => cm.trainers!.map((trainer) => trainer.id) ?? []
      );

      // Ensure uniqueness
      const uniqueTrainerIds: number[] = [...new Set(trainerIds)];

      trainerGLAValue = this.trainers
        .filter((trainer) => uniqueTrainerIds.includes(trainer.id))
        .map(
          (filteredTrainer) =>
            `${filteredTrainer.firstName} ${filteredTrainer.lastName}.${filteredTrainer.id}`
        );

      this.trainers.map((trainer) => {
        if (uniqueTrainerIds.includes(trainer.id)) {
          return;
        }
        return '';
      });
    }

    if (locationGLAIndex !== -1) {
      const trainerGLA: GroupLevelAttributeValue = {
        label: 'Trainers',
        groupLevelAttributeType: {
          id: 0,
          type: 'trainer',
          option: null
        },
        groupLevelAttributeSpec: {
          order: locationGLAIndex,
          isRequired: false
        },
        option: null,
        value: trainerGLAValue,
        attributeStatus: GroupLevelAttributeStatus.ACTIVE
      };

      this.localAttributeValues.splice(locationGLAIndex, 0, trainerGLA);
    }
  }

  processAttributeValueDisplayForGroups() {
    const logoIndex = this.localAttributeValues.findIndex(
      (gla) =>
        gla.label.toLowerCase().trim() === 'logo' &&
        gla.groupLevelAttributeType.type === 'images'
    );

    if (logoIndex !== -1) {
      this.localAttributeValues.splice(logoIndex, 1);
    }

    this.emitTitleAndLogo();
  }

  reduceAttributeValueList() {
    if (this.shouldEnableAttributeTableToggle) {
      this.hideAttributeValuesList();
    }
  }

  restoreListOfContacts() {
    this.localListOfContacts = clone(this.currentListOfContacts);
  }

  restoreAttributeValues() {
    this.localAttributeValues = clone(this.currentGroupAttributeValues);
  }

  hideListOfContacts() {
    this.localListOfContacts!.splice(
      CONTACT_OPTIONS_MAX_DISPLAY_COUNT,
      this.contactListCount - CONTACT_OPTIONS_MAX_DISPLAY_COUNT
    );
  }

  hideAttributeValuesList() {
    this.localAttributeValues!.splice(
      ATTRIBUTE_MAX_DISPLAY_COUNT,
      this.attributeCount - ATTRIBUTE_MAX_DISPLAY_COUNT
    );
  }

  emitTitleAndLogo() {
    // callback to emit title and logo value to parent for rendering
    const data: GroupTitleAndLogo = {
      title: '',
      logoUrl: ''
    };

    (this.currentGroupAttributeValues as GroupLevelAttributeValue[]).forEach(
      (attribute: GroupLevelAttributeValue) => {
        if (
          attribute.label.toLowerCase().trim() === 'title' &&
          attribute.groupLevelAttributeType.type === 'text' &&
          attribute.groupLevelAttributeSpec.order === 1
        ) {
          data.title = attribute.value as string;
        }

        if (
          attribute.label.toLowerCase().trim() === 'logo' &&
          attribute.groupLevelAttributeType.type === 'images'
        ) {
          const logoValue = attribute.value as string | string[] | null;

          if (Array.isArray(logoValue) && logoValue.length > 0) {
            data.logoUrl = logoValue[0];
          } else if (typeof logoValue === 'string') {
            data.logoUrl = logoValue;
          }
        }
      }
    );

    this.$emit('groupTitleAndLogo', data);
  }

  downloadFile(fileUrl: string) {
    return saveAs(fileUrl, fileUrl.split('/').pop());
  }

  @Watch('getAllTrainersApiState', { deep: true })
  onGetAllTrainers(state: ApiState) {
    if (state.success) {
      this.allTrainers = this.trainers;
    }
  }
}
